import ChatService from "./chat"
import SupportService from "./support"
import UserService from "./user"

const ApiService = {
    ...ChatService,
    ...SupportService,
    ...UserService,
}

export default ApiService